import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

type AgreeButtonProps = {
  disabled: boolean;
  setIsSuccess: (success: boolean) => void;
  companyId: string;
  isChecked: boolean;
};

const baseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

export default function AgreeButton({
  disabled,
  setIsSuccess,
  companyId,
  isChecked,
}: AgreeButtonProps) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const handleAgree = async () => {
    if (isChecked && companyId) {
      try {
        const response = await fetch(`${baseUrl}/api/tmc/confirm-tmc`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            langcode: i18n.language ?? "en-US",
          },
          body: JSON.stringify({
            token: token ?? "",
            companyIdentifier: companyId,
            isValid: true,
          }),
        });
        if (!response.ok) throw new Error("Network response was not ok");
        setIsSuccess(true);
        navigate(`/${i18n.language}/success`, {
          state: {
            title: t("tmc.tmcSuccessTitle"),
            description: t("tmc.tmcSuccessDesc"),
            btn: "show",
          },
        });
      } catch (error) {
        navigate(`/${i18n.language}/error`, {
          state: {
            title: t("tmc.invalidTmcTokenTitle"),
            description: t("tmc.invalidTmcTokenDesc"),
            errorBtn: "hide",
          },
        });
      }
    } else {
      alert(t("tmc.companyId"));
    }
  };
  return (
    <button
      onClick={handleAgree}
      className="rounded-xl w-full self-center bg-[#eabe4d] py-2 max-md:px-4 cursor-pointer text-lg font-semibold text-whitebitBlack disabled:opacity-50 disabled:cursor-not-allowed border border-gray-400 hover:bg-gray-200 max-w-[320px]"
      disabled={disabled}
    >
      <span>{t("tmc.agree")}</span>
    </button>
  );
}
